import { TableCell, TableRow } from '@material-ui/core';
import React, { useMemo } from 'react';
import * as DTO from '../../dto';
import { QueryType } from '../../helpers/query';
import { format } from 'date-fns';
import { LanguageString } from '..';

interface RecordOfContactsTableBodyProps {
  rocs: DTO.Roc[];
  columns: string[];
  selectedRoc: (roc: QueryType<DTO.Roc>) => void;
  rocTypes: DTO.ROCType[];
}

const formatDate = (dateStr: string) => format(new Date(dateStr), 'MM/dd/yyyy');

const ROCTableValue: React.FC<{ column: string, roc: DTO.Roc, rocType: DTO.ROCType | undefined }> = ({ column, roc, rocType }) => {

  const value = useMemo(() => {
    if (roc.values && roc.values.length > 0) {
      return roc.values.find(v => v.column === column)?.value;
    }

    return undefined;
  }, [column, roc.values]);

  switch (column) {
    case 'doc':
      return <>{roc.date != null ? formatDate(roc.date) : 'unknown'}</>;
    case 'toc':
      return rocType ? <LanguageString languageString={rocType.name} /> : <>{'unknown'}</>;
    case 'from':
      return <>{roc.contactedBy}</>;
    default:
      return (
        <>
          {value}
        </>
      );
  }
};

export const RecordOfContactsTableBody: React.FC<RecordOfContactsTableBodyProps> = ({ rocs, columns, selectedRoc, rocTypes }) => {

  return (
    <>
      {rocs.map(roc => (
        <TableRow hover tabIndex={-1} key={'roc_' + roc.rocId} selected={false} onClick={() => { selectedRoc(roc); }} >
          {columns.map((col, i) => (
            <TableCell key={`roc_value_${i}`}>
              <ROCTableValue column={col} roc={roc} rocType={rocTypes.find(t => t.id === roc.typeId)} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default RecordOfContactsTableBody;
